module.exports = __webpack_public_path__ + "static/media/construction_road_map_bg_pic.fddf22fb.jpg";